<script setup lang="ts">
import { toRefs } from '@vueuse/core'
import type { ScheduleEvent, Team } from '~/types'

interface Props {
  scheduleEvent: ScheduleEvent.Model
  team: Team.Model
}

const props = defineProps<Props>()
const { scheduleEvent, team } = toRefs(props)
const {
  eventDateFormatted,
  time,
  statusText,
  isTbd,
} = useScheduleEvent(scheduleEvent, team)
</script>

<template>
  <div class="next-game-date">
    <span
      v-if="eventDateFormatted"
      class="next-game-date__day"
    >
      {{ eventDateFormatted }}
    </span>
    <time
      v-if="time && !isTbd"
      class="next-game-date__time"
    >
      {{ time }}
    </time>
    <span
      v-else-if="statusText"
      class="next-game-date__status-text"
    >{{ statusText }}</span>
  </div>
</template>

<style scoped lang="scss">
.next-game-date {
  @apply mt-[5px] text-primary/60 flex items-center gap-[6px];
}
</style>
